<template>
  <div class="content">
    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <b-breadcrumb>
      <b-breadcrumb-item active>Clientes</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-4">
          <b-form-input v-model="searchCliente" placeholder="Buscar cliente"></b-form-input>
        </div>
        <div class="col-4">
          <select v-model="rolSearch" @change="getClientesByRol($event)" class="form-control">
            <option value="null" selected disabled hidden>Roles...</option>
            <option value="0">Todos los roles</option>
            <option value="3">Cliente Administrador</option>
            <option value="4">Cliente Usuario</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
              <h4 class="text-center">¿Seguro que quiere eliminar al cliente?</h4>
              <h5 class="text-center">Se eliminarán todos los datos.</h5>
              <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
              <b-button class="mt-3 float-right" variant="primary" @click="deleteCliente()">OK</b-button>
            </b-modal>

            <div class="text-center">
              <b-table :fields="fields" :items="clientes" hover>
                <template #cell(index)="{ index }">
                  {{ getIndex(index + 1) }}
                </template>
                <template #cell(acciones)="{ index, item }">
                  <b-row>
                    <router-link class="editBtn" :to="{ name: 'EditCliente', params: { id: item.id } }" custom>
                      <b-button variant="warning" size="sm" v-b-tooltip.hover title="Editar">
                        <b-icon-pencil />
                      </b-button>
                    </router-link>

                    <b-button
                      class="editBtn"
                      variant="danger"
                      @click="predeleteCliente(item.id)"
                      size="sm"
                      v-b-tooltip.hover
                      title="Eliminar"
                    >
                      <b-icon-trash />
                    </b-button>

                    <b-button @click="editNotaClienteHandler(index)" size="sm" v-b-tooltip.hover title="Notas de trabajo">
                      <b-icon-journal-text />
                    </b-button>
                  </b-row>
                </template>
              </b-table>
            </div>

            <div class="d-flex justify-content-between pages">
              <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalClientes" />

              <span>Mostrando {{ clientes.length }} registros de {{ totalClientes }}</span>
            </div>
          </card>
        </div>
      </div>
    </div>

    <b-modal no-close-on-backdrop centered hide-footer id="modal-notas-clientes" title="Notas de trabajo" size="lg">
      <div>
        <b-form-textarea id="textarea" v-model="currentNotaCliente.notas" rows="3" max-rows="8" no-resize></b-form-textarea>
        <p class="mt-2 info">{{ ultimaModificacionNotaClienteComputed }}</p>
      </div>
      <b-button class="mt-3" variant="danger" @click="hideModalNotasClientes">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="guardarNotaClienteHandler">Guardar</b-button>
    </b-modal>
  </div>
</template>

<script>
import { ClientesApi, RolesApi, NotasClientesApi } from "@/api";

export default {
  name: "Clientes",

  data: () => ({
    loading: false,
    currentPage: 1,
    perPage: 10,
    rolSearch: null,
    personaSearch: null,
    // totalItems: 0,
    totalClientes: 0,
    searchCliente: null,

    roles: [],
    clientes: [],

    currentClienteId: null,
    currentClienteIndex: null,

    existsNotaCliente: false,
    currentNotaCliente: {
      id: null,
      creado: null,
      actualizado: null,
      activo: null,
      cliente_id: null,
      notas: null,
    },
  }),

  computed: {
    fields() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "nombre_comercial", label: "Nombre comercial", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "email", label: "Email", class: "text-center" },
        { key: "rol", label: "Rol", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },

    ultimaModificacionNotaClienteComputed() {
      if (!this.currentNotaCliente.actualizado) {
        return "";
      }

      const date = new Date(this.currentNotaCliente.actualizado);
      date.setHours(date.getHours() - 6);
      const localDate = date.toLocaleString();

      return "Última modificación: " + localDate;
    },
  },

  watch: {
    currentPage: "getClientes",
    searchCliente: "getClientes",
  },

  created() {
    this.getClientes();
  },

  methods: {
    getIndex(index) {
      return index + (this.currentPage - 1) * this.perPage;
    },

    async getClientes() {
      try {
        this.loading = true;

        const {
          odata_page: page,
          odata_total: total,
          odata_perpage: perPage,
          value,
        } = await ClientesApi.list({
          page: this.currentPage,
          data: this.searchCliente,
          registersPerPage: this.perPage,
          rol: this.rolSearch,
          persona: this.personaSearch,
          // usuario: this.usuario,
        });

        this.currentPage = page;
        this.totalClientes = total;

        await this.getRoles();

        for (let i = 0; i < value.length; i++) {
          const role_id = value[i].roles_id;
          const obj = this.roles.find((o) => o.id === role_id);
          value[i].rol = obj.rol;
        }

        this.clientes = value;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getClientesByRol(event) {
      const value = event.target.value;

      this.rolSearch = value;

      if (value === 0) {
        this.rolSearch = null;
      }

      this.getClientes();
    },

    async getClientesByPersona(event) {
      let value = event.target.value;
      this.personaSearch = value;
      if (value === "null2") {
        this.personaSearch = null;
      }
      this.getClientes();
    },

    async getRoles() {
      try {
        const { value } = await RolesApi.list({
          page: 0,
          registersPerPage: 0,
        });
        this.roles = value;
      } catch (error) {
        // this.$swal({
      }
    },

    predeleteCliente(id) {
      this.currentClienteId = id;
      this.$refs["modal-confirm-dialog"].show();
    },

    async deleteCliente() {
      this.loading = true;
      try {
        let id = this.currentClienteId;

        await ClientesApi.delete(id);
        var index = this.clientes.findIndex(function (o) {
          return o.id === id;
        });
        this.clientes.splice(index, 1);
        this.totalClientes--;

        this.$toast.success("Cliente eliminado", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      }
      this.$refs["modal-confirm-dialog"].hide();
    },

    showModalNotasClientes() {
      this.$bvModal.show("modal-notas-clientes");
    },

    hideModalNotasClientes() {
      this.$bvModal.hide("modal-notas-clientes");
    },

    editNotaClienteHandler(clienteIndex) {
      this.currentClienteIndex = clienteIndex;
      this.editNotaCliente();
    },

    guardarNotaClienteHandler() {
      this.guardarNotaCliente();
    },

    async editNotaCliente() {
      try {
        this.loading = true;

        const cliente = this.clientes[this.currentClienteIndex];
        const { value } = await NotasClientesApi.list({
          page: 0,
          registersPerPage: 0,
          clienteId: cliente.id,
        });

        if (value.length === 0) {
          this.existsNotaCliente = false;
          this.currentNotaCliente = {
            id: null,
            creado: null,
            actulizado: null,
            activo: null,
            cliente_id: cliente.id,
            notas: null,
          };
        } else {
          this.existsNotaCliente = true;
          this.currentNotaCliente = value[value.length - 1];
        }

        this.showModalNotasClientes();
      } catch (error) {
        console.log(error);

        this.$toast.error("Error al cargar la información", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async guardarNotaCliente() {
      try {
        this.loading = true;

        if (this.existsNotaCliente) {
          await NotasClientesApi.edit(this.currentNotaCliente.id, this.currentNotaCliente);
        } else {
          const result = await NotasClientesApi.create({
            cliente_id: this.currentNotaCliente.cliente_id,
            notas: this.currentNotaCliente.notas
          });

          this.currentNotaCliente = result;
        }

        this.$toast.success("Información guardada", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        this.hideModalNotasClientes();
      } catch (error) {
        console.log(error);

        this.$toast.error("Error al guardar la información", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    cancelEditNotaCliente() {
      this.hideModalNotasClientes();
    },
  },
};
</script>
